// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_RsU","cls2":"HeroWorkCardHeader-cls2_X2V HeroWorkCardHeader-cls1_RsU"};